module.exports = __webpack_public_path__ + "static/logo-6a6f5dccc5eab0106f804aad99d38724.png";